function fillKlaviyoPopupEmail(email, formId) {
  // Klaviyo fires a native 'klaviyoForms' event on window when the popup is fully rendered.
  // type === 'open' means the form is visible in the DOM and ready to interact with.
  function onKlaviyoOpen(e) {
    if (e.detail.type !== 'open' || e.detail.formId !== formId) return;

    window.removeEventListener('klaviyoForms', onKlaviyoOpen);

    // Search for the email input inside the rendered popup.
    // Klaviyo renders popups as a sibling <div> at the end of <body>,
    // not necessarily with a predictable class — so we target the first
    // visible email input that is NOT our own footer form.
    // The 'open' event can fire before the popup is painted, so we retry
    // until the input has a non-zero width (max ~2 s, every 100 ms).
    var footerForm = document.getElementById('klavyio-form-newsletter');
    var attempts = 0;
    var maxAttempts = 20;

    function findAndFill() {
      var allEmailInputs = Array.from(document.querySelectorAll('input[type="email"]'));
      var popupInput = allEmailInputs.find(function (el) {
        return !footerForm.contains(el) && el.getBoundingClientRect().width > 0;
      });

      if (!popupInput) {
        attempts++;
        if (attempts < maxAttempts) setTimeout(findAndFill, 100);
        return;
      }

      // Use the native setter so React/framework bindings inside Klaviyo detect the change
      var nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      nativeSetter.call(popupInput, email);
      popupInput.dispatchEvent(new Event('input', { bubbles: true }));
      popupInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    findAndFill();
  }

  window.addEventListener('klaviyoForms', onKlaviyoOpen);

  // Safety: remove listener after 10 seconds if popup never fires
  setTimeout(function () {
    window.removeEventListener('klaviyoForms', onKlaviyoOpen);
  }, 10000);
}

(function () {
  var form = document.getElementById('klavyio-form-newsletter');
  if (!form) return;

  document.getElementById('klavyio-form-newsletter').addEventListener('submit', function (event) {
    event.preventDefault();
    var email = this.querySelector('input[type="email"]').value;

    switch (Shopify.locale) {
      case 'it':
        var klaviyoFormId = 'XZfnW3';
        break;
      case 'fr':
        var klaviyoFormId = 'VfDrsg';
        break;
      default:
        var klaviyoFormId = 'WfrKCr';
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', klaviyoFormId]);
    if (email) fillKlaviyoPopupEmail(email, klaviyoFormId);
  });
})();
